var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToyota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5c-6.729 0-12-3.294-12-7.5s5.271-7.5 12-7.5S24 7.794 24 12s-5.271 7.5-12 7.5zM12 6C6.309 6 1.5 8.748 1.5 12s4.809 6 10.5 6 10.5-2.748 10.5-6S17.691 6 12 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.786c-4.019 0-8.087-1.251-8.087-3.643S7.981 4.5 12 4.5s8.087 1.251 8.087 3.643-4.068 3.643-8.087 3.643zM12 6C7.979 6 5.413 7.269 5.413 8.143c0 .874 2.566 2.143 6.587 2.143s6.587-1.269 6.587-2.143C18.587 7.269 16.021 6 12 6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5c-2.101 0-3.685-3.224-3.685-7.5S9.899 4.5 12 4.5s3.685 3.224 3.685 7.5-1.584 7.5-3.685 7.5zM12 6c-.891 0-2.185 2.337-2.185 6s1.294 6 2.185 6 2.185-2.337 2.185-6S12.891 6 12 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyota);
export default __webpack_public_path__ + "static/media/toyota.86bcd2cfd4d1c44ef7d5b18ee1ff2e6b.svg";
export { ForwardRef as ReactComponent };